import styled from "styled-components";

export const Input = styled.input`
  height: 100%;
  width: 100%;
  border: 1px solid black;
`;
